module.exports = __webpack_public_path__ + "img/black.2c90f45d.png";